module.exports = __webpack_public_path__ + "img/2.28bd5205.png";